import React from "react";
import { Reveal } from "@/components/Reveal";
import useSeo from "@/lib/useSeo";

export default function Policies() {
  useSeo({ title: "Pricing & Policies", description: "VacanzaGo booking, payment and cancellation policies." });
  const sections = [
    { h: "Booking confirmation", p: "A 30% advance confirms your slot. 60% is due on Day 1 of the tour at the first hotel. The final 10% is settled during the trip (by Day 3). We accept UPI, NEFT and RTGS — full bank details are shared once you confirm." },
    { h: "Cancellation", p: "45+ days before check-in: 5% retention. 30–44 days: 15%. 16–29 days: 25%. 7–15 days: 50%. 4–6 days: 75%. Within 72 hours / no-show: 100%." },
    { h: "Pricing", p: "Standard curated journeys show a starting-from price per person. Premium, custom, corporate, B2B and event requirements are quote-based and itemised. Prices exclude airfare/train fare unless stated." },
    { h: "Force majeure", p: "Vacanza Go is not liable for delays or changes due to weather, road closures, natural events or circumstances beyond our control. We will always do our best to find safe alternatives." },
  ];
  return (
    <div className="pt-28 pb-24 bg-[#FFF7EC] min-h-screen">
      <div className="max-w-3xl mx-auto px-4 sm:px-8 lg:px-12">
        <Reveal className="mb-10">
          <p className="eyebrow">Pricing & Policies</p>
          <h1 className="font-display text-5xl sm:text-6xl font-medium tracking-tight mt-3 text-[#2A1808]">The fine print, kept fair</h1>
        </Reveal>
        <div className="space-y-8">
          {sections.map((s, i) => (
            <Reveal key={s.h} delay={i * 60}>
              <div className="rounded-md border border-[#553204]/10 bg-[#FFFBF5] p-7">
                <h2 className="font-display text-2xl text-[#2A1808]">{s.h}</h2>
                <p className="mt-2 text-[#553204] leading-relaxed">{s.p}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  );
}
